import { Code, Paper, Stack, Text } from '@mantine/core';

import type { RequestLog } from '@admin/hooks';

interface RequestTabProps {
  request: RequestLog;
}

export const RequestTab = ({ request }: RequestTabProps) => {
  return (
    <Stack gap="md">
      <Paper withBorder p="md">
        <Text size="sm" fw={600} mb="xs">
          Request Details
        </Text>
        <Stack gap="xs">
          <div>
            <Text size="xs" c="dimmed" mb={4}>
              Method
            </Text>
            <Code>{request.request?.method}</Code>
          </div>
          <div>
            <Text size="xs" c="dimmed" mb={4}>
              URL
            </Text>
            <Code block>{request.request?.url}</Code>
          </div>
          <div>
            <Text size="xs" c="dimmed" mb={4}>
              IP Address
            </Text>
            <Code>{request.request?.ip}</Code>
          </div>
        </Stack>
      </Paper>

      {request.request?.query && Object.keys(request.request.query).length > 0 && (
        <Paper withBorder p="md">
          <Text size="sm" fw={600} mb="xs">
            Query Parameters
          </Text>
          <Code block>{JSON.stringify(request.request.query, null, 2)}</Code>
        </Paper>
      )}

      {request.request?.params && Object.keys(request.request.params).length > 0 && (
        <Paper withBorder p="md">
          <Text size="sm" fw={600} mb="xs">
            URL Parameters
          </Text>
          <Code block>{JSON.stringify(request.request.params, null, 2)}</Code>
        </Paper>
      )}

      {request.request?.body && (
        <Paper withBorder p="md">
          <Text size="sm" fw={600} mb="xs">
            Request Body
          </Text>
          <Code block style={{ maxHeight: '400px', overflow: 'auto' }}>
            {JSON.stringify(request.request.body, null, 2)}
          </Code>
        </Paper>
      )}

      {request.request?.cookies && Object.keys(request.request.cookies).length > 0 && (
        <Paper withBorder p="md">
          <Text size="sm" fw={600} mb="xs">
            Cookies
          </Text>
          <Code block>{JSON.stringify(request.request.cookies, null, 2)}</Code>
        </Paper>
      )}
    </Stack>
  );
};
